import { FiAlertTriangle, FiEdit } from 'react-icons/fi';
import { useFlagActions, useFlags } from 'utils/hooks/flags';
import styled from 'styled-components';
import { withMixpanelClick } from 'utils/app';

function FeedbackFlagWrapper({ flagId, flagData, children, ...props }) {
    const { flagItem, unflagItem } = useFlagActions();
    const { data: flags } = useFlags();
    const isFlagged = (flags || []).some(
        (currentFlagId) => flagId === currentFlagId,
    );
    return (
        <span {...props}>
            <span css={isFlagged ? `opacity: .5;` : ``}>{children}</span>
            <ButtonWrapper>
                <Button
                    mixpanelMeta={{ isFlagged }}
                    onClick={() =>
                        (isFlagged ? unflagItem : flagItem)({
                            flagId,
                            data: flagData,
                        })
                    }
                    aria-label={
                        isFlagged
                            ? `Remove this flag`
                            : `Flag as miscategorized or irrelevant`
                    }
                >
                    {isFlagged ? (
                        <FiAlertTriangle
                            css={`
                                width: 1em;
                                height: 1em;
                                color: ${({ theme }) => theme.yellow_2};
                            `}
                        />
                    ) : (
                        <FiEdit css="width: 1em; height: 1em; color: inherit;" />
                    )}
                </Button>
            </ButtonWrapper>
        </span>
    );
}

const ButtonWrapper = styled.span`
    color: ${({ theme }) => theme.gray_4};
    padding-left: 4px;
    display: inline-flex;
    align-items: center;
`;

const Button = withMixpanelClick(
    styled.button`
        background: transparent;
        border: 0;
        padding: 0;
        margin: 0;
        cursor: pointer;
        font-size: inherit;
        width: 1em;
        height: 1em;
        line-height: 1em;
        display: inline-flex;
        align-items: center;
    `,
    'FlagButton',
);

export default FeedbackFlagWrapper;
